export enum BannerInteractionEventType {
    BannerClick = 'Banner Click',
    BannerView = 'Banner View'
}
